import React, { Component } from 'react';
// import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import config from 'config/api';
// import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
// import './Mission.css';
import { withRouter } from 'react-router-dom';
// import IconArrow from '@material-ui/icons/ArrowLeft';
import ScrollToTopOnMount from '../ScrollToTopOnMount';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
// import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Template from 'components/Template';
import Button from '@material-ui/core/Button';

// import Immutable from 'immutable';

import { fetchData, clearData, getDataMissions, getLoadingError } from '../../ducks/asyncFetcher';

import { isLoggedIn } from '../../ducks/authentication';

const AF_KEY = 'missions';

const styles = (theme) => {
  return {
    root: {
      color: '#322F30',
      maxWidth: 800,
      width: '90%',
      padding: '0 20px',
      margin: '0 auto',
      '& .MuiAccordion-root:before': {
        display: 'none',
      },
      '& .MuiAccordion-rounded': {
        marginBottom: theme.spacing(4),
        boxShadow: '0 0 10px #e8e8e8',
      },
      '& .MuiAccordionSummary-expandIcon': {
        color: theme.palette.secondary.main,
        border: '1px #D9D5D3 solid',
        padding: 3,
      },
      '& .MuiAccordionSummary-root': {
        paddingTop: 10,
        paddingBottom: 10,
      },
    },
    candidates: {
      width: '100%',
    },
    candidate: {
      backgroundColor: '#F6F6F6',
      marginBottom: 5,
      width: '100%',
      padding: '10px 20px',
      '& .MuiTypography-body1': {
        fontSize: '1.1rem',
      },
    },
    button: {
      fontSize: '1rem',
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.875rem',
      },
    },
    inline: {
      display: 'inline-block',
      verticalAlign: 'middle',
    },
    heading: {
      fontSize: '1.4rem',
    },
    bold: {
      fontWeight: 700,
    },
    bullet: {
      color: theme.palette.secondary.main,
      marginLeft: 5,
      marginRight: 5,
    },
  };
};
class Mission extends Component {
  constructor(props) {
    super(props);
    this.$left = false;
    this.$right = false;
    this.state = {
      expanded: false,
    };
  }
  componentDidMount() {
    this.props.onMount(this.props.missionId, this.props.ficheId);

    // this._resize = this._resize.bind(this);
    // window.addEventListener('resize', this._resize);
  }
  compoentnWillUnmount() {
    // window.removeEventListener('resize');
  }
  componentDidUpdate(oldProps) {
    // if (oldProps.missionId !== undefined && oldProps.missionId !== this.props.missionId)
    if (oldProps.missionId !== this.props.missionId) this.props.onMount(this.props.missionId);

    // if (
    //   oldProps.$$data !== undefined &&
    //   oldProps.$$data.get('missions') !== undefined &&
    //   this.props.$$data !== undefined &&
    //   this.props.$$data.get('missions') !== undefined &&
    //   oldProps.$$data.get('missions').get('details') !== this.props.$$data.get('missions').get('details')
    // ) {
    //   console.log('CHANGED');
    //   const newExpanded = this.state;
    //   this.setState({ expanded: newExpanded });
    // }
    // if (oldProps.$$data === undefined && this.props.$$data !== undefined) this._resize();
  }
  // _resize() {
  //   if (!this.$left || !this.$right) return;
  //
  //   const maxHeight = window.innerHeight;
  //   console.log(this.$left, maxHeight);
  //   if (this.$left.offsetHeight < maxHeight) {
  //     console.log('too small !');
  //     this.$left.height = maxHeight;
  //   }
  //   if (this.$right.height < maxHeight) this.$right.height = maxHeight;
  // }

  _handleChange = async (itm) => {
    const { onFetchMissionDetails } = this.props;
    const { expanded } = this.state;
    // console.log({ itm, expanded });
    const newExpanded = expanded === itm ? false : itm;
    // console.log({ itm, expanded, test: newExpanded });
    if (expanded !== itm) {
      const foo = await onFetchMissionDetails(itm);
      setTimeout(() => {}, 200);
    }
    // this.setState({ newExpanded: newExpanded });
    this.setState({ expanded: newExpanded });
  };
  render() {
    const { $$data, isLoggedIn, classes } = this.props;
    const { expanded } = this.state;
    if (!isLoggedIn) {
      return (
        <Redirect
          to={{
            pathname: '/',
            state: { from: this.props.location },
          }}
        />
      );
    }
    // if ($$data !== undefined)
    // console.log($$data.get('missions').get('details').toJS())
    return (
      <Template title={<Typography variant="h1">Liste des Missions associées</Typography>} fit={true}>
        <div className={classes.root}>
          <Choose>
            <When condition={$$data !== undefined}>
              <ScrollToTopOnMount />

              {$$data
                .get('missions')
                .get('index')
                .map((mission, i) => {
                  return (
                    <Accordion
                      key={'acc_' + i}
                      expanded={expanded !== undefined && expanded === mission.get('id')}
                      onChange={() => {
                        this._handleChange(mission.get('id'));
                      }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <Typography className={classes.heading}>
                          {mission.get('code_mission')}
                          <If condition={mission.get('type_poste')}>
                            <span className={classes.bullet}>&bull;</span>{' '}
                            <span className={classes.bold}>{mission.get('type_poste')}</span>
                          </If>
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <List component="nav" aria-label="candidats" className={classes.candidates}>
                          <If condition={$$data.get('missions').get('details') !== null}>
                            <ScrollToTopOnMount />
                            {$$data
                              .get('missions')
                              .get('details')
                              .map((item, i) => {
                                return (
                                  <ListItem
                                    key={'mission_' + mission.get('id') + '_' + item.get('code_candidat')}
                                    className={classes.candidate}
                                  >
                                    <ListItemText
                                      primary={
                                        <div>
                                          <Typography
                                            variant="body1"
                                            style={{ color: '#747273', marginRight: 5 }}
                                            className={classes.inline}
                                          >
                                            <span>Label N°{item.get('code_candidat')} - </span>
                                          </Typography>
                                          <Typography
                                            variant="body1"
                                            style={{ color: '#322F30' }}
                                            className={classes.inline}
                                          >
                                            {item.get('prenom')} {item.get('nom')}
                                          </Typography>
                                        </div>
                                      }
                                    />
                                    <Button
                                      variant="contained"
                                      color="secondary"
                                      className={classes.button}
                                      onClick={() => {
                                        this.props.history.push(
                                          '/mission/' + expanded + '/fiche/' + item.get('id'),
                                        );
                                      }}
                                    >
                                      Consulter la fiche
                                    </Button>
                                  </ListItem>
                                );
                              })
                              .toArray()}
                          </If>
                        </List>
                      </AccordionDetails>
                    </Accordion>
                  );
                })
                .toArray()}
            </When>
            <Otherwise></Otherwise>
          </Choose>
        </div>
      </Template>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataMissions(state),
    error: getLoadingError(state),
    isLoggedIn: isLoggedIn(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {
      dispatch(fetchData({ key: 'home', fetchUrl: config.home }));
      dispatch(fetchData({ key: AF_KEY, fetchUrl: config.missions.replace(':missionId', '') }));
    },
    onFetchMissionDetails: (missionId) => {
      dispatch(clearData({ key: AF_KEY }));
      dispatch(fetchData({ key: AF_KEY, fetchUrl: config.missions.replace(':missionId', missionId || '') }));
    },
  };
}
// export default Mission;
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles)(Mission)));



// WEBPACK FOOTER //
// ./src/components/Mission/Mission.jsx